module.exports = __webpack_public_path__ + "static/img/light_new.2965dc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/light_new.png
// module id = RQK/
// module chunks = 1